import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Tooltip,
  IconButton,
} from "@mui/material";
import { Cross } from "../../../shared/assets/icons";
import Modal from "@mui/material/Modal";
import Styles from "../../../styles/vendorDashboard.module.css";
import { useEffect } from "react";
import CommentIcon from "@mui/icons-material/Comment";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DeleteIcon from "@mui/icons-material/Delete";

import axios from "axios";
import CommentModal from "../../../shared/createForms/CommentModal";
import GlobalButton from "../../../shared/utils/GlobalButton";

const InstallationPartnerModal = ({
  selectedInstallationPartnerData,
  setIsInstallationPartnerModalOpen,
  setSelectedInstallationPartnerData,
  setAnchorEl,
  setSnackbar,
}) => {
  // handlers
  const serverURL = process.env.REACT_APP_URL;
  const [commentModal, setCommentModal] = useState(false);
  const [ipId, setIpId] = useState("");
  const [comment, setComment] = useState("");
  const [loading, setCommentLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [allComments, setAllComments] = useState([]);
  // const [currentIndex, setCurrentIndex] = useState(0);
  const [currentImageUrl, setCurrentImageUrl] = useState(null);
  const [imageError, setImageError] = useState(false);
  // Function to format date and remove time and timezone
  const formatDate = (dateString) => {
    if (!dateString) return "Not Available";
    const date = new Date(dateString);
    return date.toLocaleDateString(); // This will return the date in the format 'MM/DD/YYYY'
  };

  const handleSubmit = async () => {
    if (!comment.trim()) return;

    setCommentLoading(true);

    // Simulate API call delay
    try {
      const response = await axios.post(
        `${serverURL}/installationPartner/comment/${ipId}`,
        {
          comment,
          userId: localStorage.getItem("userId"),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.data.success) {
        fetchComments();

        setSnackbar({
          open: true,
          message: "Thank you for your feedback",
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: "Their was an error while sending your feedback",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Their was an error while sending your feedback",
        severity: "error",
      });
    }

    setCommentLoading(false);
    setComment("");
    handleCloseCommentModal();
  };
  const handleClose = () => {
    setIsInstallationPartnerModalOpen(false);
  };

  const handleCloseCommentModal = () => {
    setCommentModal(false);
  };

  const handleDelete = async (commentId) => {
    try {
      const response = await axios.delete(
        `${serverURL}/installationPartner/deleteComment/${commentId}`,

        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      fetchComments();
    } catch (error) {
      console.error(error);
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  let role = localStorage.getItem("role");

  const basicInfo = [
    {
      label: "Name",
      value: selectedInstallationPartnerData?.name || "Not Available",
    },
    {
      label: "Gender",
      value: selectedInstallationPartnerData?.gender || "Not Available",
    },
    {
      label: "DOB",
      value:
        formatDate(selectedInstallationPartnerData?.dateOfBirth) ||
        "Not Available",
    },
    {
      label: "Experience",
      value: selectedInstallationPartnerData?.experience || "Not Available",
    },
    {
      label: "Prior Knowledge of installation",
      value: selectedInstallationPartnerData?.priorKnowledgeOfInstallation
        ? "Yes"
        : "No" || "Not Available",
    },
  ];

  const contactDetails = [
    {
      label: "State",
      value: selectedInstallationPartnerData?.state || "Not Available",
    },
    {
      label: "City",
      value: selectedInstallationPartnerData?.city || "Not Available",
    },
    ...(role != 1
      ? [
          {
            label: "Address",
            value: selectedInstallationPartnerData?.address || "Not Available",
          },
          {
            label: "Phone Number",
            value:
              selectedInstallationPartnerData?.phoneNumber || "Not Available",
          },
          {
            label: "Zip Code",
            value: selectedInstallationPartnerData?.zipCode || "Not Available",
          },
        ]
      : []),
  ];
  const educationAndWorkExperience = [
    {
      label: "ITI Course",
      value: selectedInstallationPartnerData?.itiCourse || "",
    },
  ];
  const otherDetails = [
    {
      label: "Bank Name",
      value:
        selectedInstallationPartnerData?.bankDetails?.bankName ||
        "Not Available",
    },
    {
      label: "Aadhaar Card",
      value:
        selectedInstallationPartnerData?.aadhaarCardNumber || "Not Available",
    },
    {
      label: "Bank A/C No",
      value:
        selectedInstallationPartnerData?.bankDetails?.accountNumber ||
        "Not Available",
    },
    {
      label: "IFSC Code",
      value:
        selectedInstallationPartnerData?.bankDetails?.IFSC || "Not Available",
    },
    {
      label: "Bank A/C Holder Name",
      value:
        selectedInstallationPartnerData?.bankDetails?.bankHolderName ||
        "Not Available",
    },
    {
      label: "Pan Number",
      value:
        selectedInstallationPartnerData?.bankDetails?.panNumber ||
        "Not Available",
    },
    {
      label: "Status",
      value: selectedInstallationPartnerData?.status || "Not Available",
    },
    {
      label: "Installation Rate",
      value:
        selectedInstallationPartnerData?.bankDetails?.installationRate ||
        "Not Available",
    },
    {
      label: "Category",
      value: selectedInstallationPartnerData?.ipCategory || "Not Available",
    },
    ...(selectedInstallationPartnerData.status === "Blacklisted"
      ? [
          {
            label: "Reason For Blacklisted",
            value:
              selectedInstallationPartnerData?.reasonForBlacklisted ||
              "Not Available",
          },
        ]
      : []),
  ];

  const educationalCertificates = [
    {
      type: "image",
      label: "10th Certificate",
      value:
        selectedInstallationPartnerData?.tenthCertificate || "Not Available",
    },
    {
      type: "image",
      label: "12th Certificate",
      value:
        selectedInstallationPartnerData?.twelfthCertificate || "Not Available",
    },
    {
      type: "image",
      label: "Graduation Certificate",
      value:
        selectedInstallationPartnerData?.graduationCertificate ||
        "Not Available",
    },
    {
      type: "image",
      label: "Diploma Certificate",
      value:
        selectedInstallationPartnerData?.diplomaCertificate || "Not Available",
    },
    {
      type: "image",
      label: "ITI Certificate",
      value: selectedInstallationPartnerData?.itiCertificate || "Not Available",
    },
  ];
  const isShowRow = educationalCertificates?.every(
    (ele) => ele.value === "Not Available",
  );

  const fetchComments = async () => {
    // Simulate API call delay
    try {
      const response = await axios.get(
        `${serverURL}/installationPartner/viewComment/${selectedInstallationPartnerData._id}`,

        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.data.success) {
        setAllComments(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchComments();
  }, [selectedInstallationPartnerData]);

  const renderSection = (title, data) => {
    return (
      <div>
        <h3 className="text-xl font-bold  text-gray-600 mb-4">{title}</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {data.map((item, index) => {
            return (
              <div className="flex flex-col">
                <span className="font-bold text-gray-600">{item.label}:</span>

                {item.type === "image" ? (
                  <>
                    {item.value &&
                    item.value !== "" &&
                    item.value != "Not Available" ? (
                      item.value.endsWith(".pdf") ? (
                        <div
                          onClick={() => handleImageClickPhoto(item.value)}
                          className="cursor-pointer"
                        >
                          <embed
                            src={item.value}
                            type="application/pdf"
                            className="h-44 w-44 object-cover rounded pointer-events-none"
                          />
                        </div>
                      ) : (
                        <img
                          src={item.value}
                          alt={item.label}
                          className="w-64 h-32 m-4 cursor-pointer"
                          onClick={() => handleImageClickPhoto(item.value)}
                          onError={() => setImageError(true)}
                        />
                      )
                    ) : (
                      <span className="text-gray-600">Not Available</span>
                    )}
                  </>
                ) : (
                  <span className="text-gray-600">
                    {item.value || "Not Available"}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const calculateAge = (dob) => {
    const birthDate = new Date(dob); // Convert the dob string to a Date object
    const today = new Date(); // Get the current date

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();

    // Adjust the age if the current date is before the birthday in the current year
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return `${age} Years`;
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [isImage, setIsImage] = useState(false);

  const handleImageClickPhoto = (imageSrc) => {
    setSelectedImage(imageSrc); // Set the clicked image's source
    // Show the modal
    setIsImage(true);
  };
  const handleCommentClick = (e, v) => {
    setCommentModal(true);
    setIpId(v);
    setAnchorEl(null);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className="flex items-center justify-center min-h-full w-full p-4 backdrop-blur-sm rounded-lg absolute">
          {/* Modal Content */}
          <div className="w-[500px] h-[450px] bg-[var(--disabled-color)] flex justify-center items-center shadow-[0_0_20px_5px_rgba(255,255,255,0.6)]">
            {currentImageUrl && (
              <div className="w-[480px] h-[430px] flex justify-center items-center">
                {currentImageUrl.endsWith(".mp4") ||
                currentImageUrl.endsWith(".mov") ? (
                  <video
                    controls
                    className="w-full h-full object-cover"
                    autoPlay
                    src={currentImageUrl}
                  />
                ) : (
                  <img
                    src={currentImageUrl}
                    alt="current-preview"
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
            )}
          </div>

          {/* Close Button */}
          <div
            className="w-8 h-8 absolute top-5 bg-[var(--disabled-color)] rounded-full flex items-center justify-center cursor-pointer"
            onClick={handleCloseModal}
          >
            <Cross color="black" size="30" />
          </div>
        </div>
      </Modal>

      <Dialog
        open={true}
        onClose={handleClose}
        fullWidth
        maxWidth="2xl" // Available options: 'xs', 'sm', 'md', 'lg', 'xl'
      >
        <div className={`flex justify-between ${Styles.vendorModalColor}`}>
          <DialogTitle className={Styles.vendorHeading}>
            Installation Partner Profile Details
          </DialogTitle>
          <div
            onClick={handleClose}
            className="mx-5 my-4"
            style={{ cursor: "pointer" }}
          >
            <Cross />
          </div>
        </div>
        <DialogContent className={Styles.vendorModalColor}>
          <Box>
            <div className="min-h-screen flex flex-col md:flex-row">
              {/* Sidebar */}
              <aside className="w-full md:w-1/4  md:mb-0 md:mr-4 ">
                {/* Profile Information */}
                <div className="text-center mb-6 bg-white rounded-lg shadow-md p-6 mb-4">
                  <img
                    src={
                      selectedInstallationPartnerData?.profilePhoto
                        ? selectedInstallationPartnerData?.profilePhoto
                        : "/assests/AdminDashboard/userForIP.webp"
                    } // Replace with actual image URL
                    alt="Profile Logo"
                    className="w-24 h-24 rounded-full mx-auto mb-4 cursor-pointer"
                    onClick={() =>
                      handleImageClickPhoto(
                        selectedInstallationPartnerData?.profilePhoto !== ""
                          ? selectedInstallationPartnerData?.profilePhoto
                          : "/assests/AdminDashboard/userForIP.webp",
                      )
                    }
                  />
                  <h2 className="text-xl font-semibold">
                    {selectedInstallationPartnerData?.emailAddress?.toLowerCase() ||
                      "Not Available"}
                  </h2>
                  <p className="text-gray-500">
                    {selectedInstallationPartnerData?.gender || "Not Available"}{" "}
                    |{" "}
                    {selectedInstallationPartnerData?.dateOfBirth
                      ? calculateAge(
                          selectedInstallationPartnerData.dateOfBirth,
                        )
                      : "Not Available"}
                  </p>
                </div>

                {/* Work Experience */}
                <div className="mb-6 bg-white rounded-lg shadow-md p-6 mb-4">
                  <h3 className="text-[#04ADE6] font-semibold mb-4">
                    Work Experience
                  </h3>
                  <ul>
                    <li className="mb-4">
                      <div className="flex justify-between">
                        <span className="text-sm font-bold">
                          Total Years Of Experience
                        </span>
                        <p className="text-gray-500">
                          {selectedInstallationPartnerData?.experience ||
                            "Not Available"}
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                {localStorage.getItem("role") === "-1" && (
                  <div className="mb-6 bg-white rounded-lg shadow-md p-6 max-h-[300px] overflow-y-auto">
                    <section className="flex justify-between items-center mb-3">
                      <h3 className="text-[#04ADE6] font-semibold mb-4">
                        Comments
                      </h3>
                      <Tooltip title="Add Comment" arrow>
                        <div
                          onClick={(e) =>
                            handleCommentClick(
                              e,
                              selectedInstallationPartnerData._id,
                            )
                          }
                          className="cursor-pointer mb-2 flex items-center justify-center border bg-[#66d4f8] shadow-sm h-8 w-8 rounded-full hover:bg-gray-200"
                        >
                          <span className="text-gray-800 text-[25px]">+</span>
                        </div>
                      </Tooltip>
                    </section>

                    <ul className="space-y-4 pr-2 ">
                      {allComments?.length > 0 ? (
                        allComments.map((ele, index) => (
                          <li
                            key={ele._id || index}
                            className="border-b pb-3  bg-gray-100 p-2 rounded-md shadow-md "
                          >
                            <div className="flex items-start justify-start gap-2 relative">
                              <IconButton
                                size="small"
                                sx={{
                                  position: "absolute",
                                  top: -20,
                                  right: -18,
                                }}
                                onClick={() => handleDelete(ele?._id)}
                              >
                                <DeleteIcon fontSize="small" color="error" />
                              </IconButton>

                              <CommentIcon
                                style={{
                                  color: "#04ADE6",
                                  fontSize: "15px",
                                  marginTop: "6px",
                                }}
                              />
                              <p className="text-gray-700 text-sm italic flex items-center gap-2 whitespace-pre-line">
                                {ele?.comment}
                              </p>
                            </div>
                            <div className="text-[12px] text-gray-500 mt-1 text-right mr-2 ">
                              Commented by{" "}
                              <span className="font-semibold text-gray-600">
                                {ele?.commentedBy?.name
                                  .charAt(0)
                                  .toUpperCase() +
                                  ele?.commentedBy?.name.slice(1) || "Unknown"}
                              </span>
                              <br />
                              <span className="text-[11px]">
                                <CalendarTodayIcon
                                  style={{
                                    color: "#04ADE6",
                                    fontSize: "13px",
                                    marginBottom: "1px",
                                  }}
                                />{" "}
                                {new Date(ele?.createdAt).toLocaleDateString(
                                  "en-IN",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  },
                                )}
                              </span>
                            </div>
                          </li>
                        ))
                      ) : (
                        <li className="text-gray-400 italic">
                          No comments yet.
                        </li>
                      )}
                    </ul>
                  </div>
                )}

                {selectedInstallationPartnerData?.bankDetails
                  ?.cancelledCheque && (
                  <div className=" bg-white rounded-lg shadow-md p-6 mb-4">
                    <h3 className="text-[#04ADE6] font-semibold mb-4">
                      Cancelled Check Photo
                    </h3>
                    <img
                      src={
                        selectedInstallationPartnerData?.bankDetails
                          ?.cancelledCheque
                          ? selectedInstallationPartnerData?.bankDetails
                              ?.cancelledCheque
                          : "/assests/AdminDashboard/cancelledCheque.png"
                      } // Replace with actual image URL
                      alt="cancelled cheque"
                      className="w-64 h-32  mx-auto mb-4 cursor-pointer"
                      onClick={() =>
                        handleImageClickPhoto(
                          selectedInstallationPartnerData?.bankDetails
                            ?.cancelledCheque !== ""
                            ? selectedInstallationPartnerData?.bankDetails
                                ?.cancelledCheque
                            : "/assests/AdminDashboard/cancelledCheque.png",
                        )
                      }
                    />
                  </div>
                )}

                {
                  <Modal
                    open={isImage}
                    // onClose={() => setFabImageModal(false)}
                    onClose={() => {
                      setIsImage(false);
                      setSelectedImage(null);
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      className="h-full flex justify-center items-center mx-auto relative"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {selectedImage?.endsWith(".pdf") ? (
                        <embed
                          src={selectedImage}
                          type="application/pdf"
                          className="w-[600px] h-[500px] object-cover rounded cursor-pointer"
                        />
                      ) : (
                        <img
                          src={selectedImage}
                          alt="Machine"
                          className="object-contain max-w-[80vw] max-h-[90vh]"
                        />
                      )}
                    </div>
                  </Modal>
                }
              </aside>

              {/* Main Content */}
              <main className="w-full md:w-3/4">
                <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                  {renderSection("Basic Information", basicInfo)}
                </div>
                <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                  {renderSection("Contact Details", contactDetails)}
                </div>
                <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                  {renderSection(
                    "Education & Work Experience",
                    educationAndWorkExperience,
                  )}
                </div>
                {role != 1 ? (
                  <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                    {renderSection("Other Details", otherDetails)}
                  </div>
                ) : (
                  <></>
                )}
                {!isShowRow && (
                  <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                    {renderSection(
                      "Education Details",
                      educationalCertificates,
                    )}
                  </div>
                )}
              </main>
            </div>
          </Box>
        </DialogContent>
        <DialogActions>
          <div className="w-30">
            <GlobalButton onClick={handleClose} variant="primary">
              {`Close`}
            </GlobalButton>
          </div>
        </DialogActions>
      </Dialog>
      {commentModal && (
        <CommentModal
          commentModal={commentModal}
          setComment={setComment}
          loading={loading}
          comment={comment}
          handleClose={handleCloseCommentModal}
          handleSubmit={handleSubmit}
        />
      )}

      {/* <div className="bg-white p-6 rounded-lg w-full max-w-4xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">InstallationPartner Details</h2>
          <div onClick={handleClose} className="cursor-pointer">
            <Cross />
          </div>
        </div>

        <hr
          className="my-4 mx-4 ml-0"
          style={{ border: "1px solid var(--disabled-color)" }}
        />

        <div className="overflow-auto max-h-96">
          <table className="table-auto border-collapse w-full">
            <tbody>
              {InstallationPartnerDetails.map((item, index) => (
                <tr key={index}>
                  <td
                    className="border px-4 py-2"
                    style={{ color: "var(--heading-color)", width: "50%" }}
                  >
                    {item.label}
                  </td>
                  <td
                    className="border px-4 py-2"
                    style={{ color: "var(--para-color)", width: "50%" }}
                  >
                    {item.value || "Not Available"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> */}
    </div>
  );
};

export default InstallationPartnerModal;
